(() => {
  const normalise = (value = '') => value.trim().toLowerCase().replace(/\s+/g, ' ');

  const profileRules = {
    wardrobe: {
      priority: ['width', 'product type', 'door count', 'colour', 'color', 'specific shade / finish', 'mirror', 'have mirror', 'drawers', 'material', 'furniture/fixture material', 'finish', 'style', 'features', 'wardrobe type', 'price'],
      allowed: ['width', 'product type', 'door count', 'colour', 'color', 'specific shade / finish', 'mirror', 'have mirror', 'drawers', 'material', 'furniture/fixture material', 'finish', 'style', 'features', 'wardrobe type', 'price']
    },
    bed: {
      priority: ['bed size', 'bedding size', 'bed type', 'bed storage', 'bed features', 'bed/frame features', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'price'],
      allowed: ['bed size', 'bedding size', 'bed type', 'bed storage', 'bed features', 'bed/frame features', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'price']
    },
    mattress: {
      priority: ['bed size', 'bedding size', 'mattress type', 'mattress firmness', 'firmness', 'mattress features', 'price'],
      allowed: ['bed size', 'bedding size', 'mattress type', 'mattress firmness', 'firmness', 'mattress features', 'price']
    },
    bedside: {
      priority: ['width', 'number of drawers', 'drawer count', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'storage format', 'furniture features', 'price'],
      allowed: ['width', 'number of drawers', 'drawer count', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'storage format', 'furniture features', 'price']
    },
    drawers: {
      priority: ['number of drawers', 'drawer count', 'width', 'storage format', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'furniture features', 'price'],
      allowed: ['number of drawers', 'drawer count', 'width', 'storage format', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'furniture features', 'price']
    },
    dressing: {
      priority: ['furniture features', 'width', 'number of drawers', 'drawer count', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'price'],
      allowed: ['furniture features', 'width', 'number of drawers', 'drawer count', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'price']
    },
    storage: {
      priority: ['storage format', 'furniture features', 'width', 'number of drawers', 'drawer count', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'price'],
      allowed: ['storage format', 'furniture features', 'width', 'number of drawers', 'drawer count', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'finish', 'style', 'price']
    },
    bedroom: {
      priority: ['product type', 'bed size', 'bedding size', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'style', 'price'],
      allowed: ['product type', 'bed size', 'bedding size', 'colour', 'color', 'specific shade / finish', 'material', 'furniture/fixture material', 'style', 'price']
    }
  };

  const retailLabels = {
    'furniture/fixture material': 'Material',
    'bedding size': 'Size',
    'bed/frame features': 'Features',
    'mattress firmness': 'Firmness',
    'number of drawers': 'Drawers'
  };

  const labelElement = (group) => group.querySelector('.filter-form__group-toggle-label');
  const labelFor = (group) => group.dataset.cwFilterKey || normalise(labelElement(group)?.textContent || '');

  const enhanceWrapper = (wrapper) => {
    const profile = wrapper.closest('[data-cw-filter-profile]')?.dataset.cwFilterProfile || 'general';
    const rules = profileRules[profile];

    wrapper.querySelectorAll('.filter-form').forEach((form) => {
      const groups = [...form.querySelectorAll('.filter-form__group')];
      const signature = [
        profile,
        ...groups.map((group) => `${labelFor(group)}:${group.querySelectorAll('[data-filter-list-item]').length}`)
      ].join('|');
      if (form.dataset.cwFilterSignature === signature) return;
      form.dataset.cwFilterSignature = signature;
      if (!rules) return;

      groups.forEach((group) => {
        const originalLabel = labelFor(group);
        group.dataset.cwFilterKey = originalLabel;
        const optionCount = group.querySelectorAll('[data-filter-list-item]').length;
        const isRedundantWardrobeType = profile === 'wardrobe' && originalLabel === 'wardrobe type' && optionCount <= 1;
        group.hidden = !rules.allowed.includes(originalLabel) || isRedundantWardrobeType;

        const friendlyLabel = retailLabels[originalLabel];
        const label = labelElement(group);
        if (friendlyLabel && label) label.textContent = friendlyLabel;
      });

      const visibleGroups = groups.filter((group) => !group.hidden);
      const groupContainer = visibleGroups[0]?.parentElement;
      if (groupContainer) {
        visibleGroups
          .sort((a, b) => {
            const aLabel = labelFor(a);
            const bLabel = labelFor(b);
            const aIndex = rules.priority.indexOf(aLabel);
            const bIndex = rules.priority.indexOf(bLabel);
            return (aIndex < 0 ? 99 : aIndex) - (bIndex < 0 ? 99 : bIndex);
          })
          .forEach((group) => groupContainer.appendChild(group));
      }
    });
  };

  const observeFilterRoots = (scope = document) => {
    const wrappers = [];
    if (scope.matches?.('[data-filter-form-wrapper]')) wrappers.push(scope);
    wrappers.push(...scope.querySelectorAll?.('[data-filter-form-wrapper]') || []);

    wrappers.forEach((wrapper) => {
      enhanceWrapper(wrapper);
      if (wrapper.dataset.cwFilterObserver === 'true') return;
      wrapper.dataset.cwFilterObserver = 'true';
      const observer = new MutationObserver(() => enhanceWrapper(wrapper));
      observer.observe(wrapper, { childList: true, subtree: true });
    });
  };

  const run = (scope = document) => observeFilterRoots(scope);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(), { once: true });
  else run();

  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();